import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
const loadImage = (onLoad, onError) => (src, isAnonymous) => {
    const imageToLoad = new Image();
    if (isAnonymous) {
        imageToLoad.crossOrigin = 'Anonymous';
    }
    // pre-load the actual image
    imageToLoad.src = src;
    imageToLoad.onload = onLoad;
    imageToLoad.onerror = onError;
    return imageToLoad;
};
const ImagePreloader = props => {
    const { src, isAnonymous, onLoaded, onFailed, children } = props;
    const [status, setStatus] = useState(ImagePreloader.STATUS_PENDING);
    const [image, setImage] = useState();
    const willUnmount = useRef();
    const handleImageLoaded = () => {
        if (willUnmount.current) {
            return;
        }
        setStatus(ImagePreloader.STATUS_LOADED);
        onLoaded(image);
    };
    const handleImageFailed = () => {
        if (willUnmount.current) {
            return;
        }
        setStatus(ImagePreloader.STATUS_FAILED);
        onFailed(image);
    };
    const loadImageWithCallbacks = loadImage(handleImageLoaded, handleImageFailed);
    useEffect(() => {
        setImage(loadImageWithCallbacks(src, isAnonymous));
        return () => {
            willUnmount.current = true;
        };
    }, []);
    useEffect(() => {
        setStatus(ImagePreloader.STATUS_PENDING);
        setImage(loadImageWithCallbacks(src, isAnonymous));
    }, [src]);
    return children({ status, image });
};
ImagePreloader.STATUS_PENDING = 'PENDING';
ImagePreloader.STATUS_LOADED = 'LOADED';
ImagePreloader.STATUS_FAILED = 'FAILED';
ImagePreloader.defaultProps = {
    onLoaded: () => { },
    onFailed: () => { },
    isAnonymous: false,
};
ImagePreloader.propTypes = {
    src: PropTypes.string.isRequired,
    onLoaded: PropTypes.func,
    onFailed: PropTypes.func,
    isAnonymous: PropTypes.bool,
};
export default ImagePreloader;
